import { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useTabNavigation } from 'src/redux/slices/navigation/hooks'
import { getProject } from 'src/redux/slices/project/endpoints'
import { isLoading } from 'src/redux/slices/project/selectors'
import { Entrypoint } from 'src/redux/slices/umibuilder/consts'
import {
  clearAllData,
  loadGroupData,
  setCloudContext,
  setEntrypoint,
} from 'src/redux/slices/umibuilder/reducers'
import { selectSummaryData } from 'src/redux/slices/umibuilder/selectors'

import Button from '@material-ui/core/Button'
import LinearProgress from '@material-ui/core/LinearProgress'
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'
import CallSplitIcon from '@material-ui/icons/CallSplit'

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    centered: {
      margin: '0 auto',
    },
    left: {
      marginRight: 'auto',
    },
  }),
)

export const TaskDetailSegment: React.FC = () => {
  return (
    <Typography variant='body2'>
      Define how the buildings are sorted into archetypes using the metadata identified by the GIS
      Manager - typically program type (e.g. Restaurant, Hospital, etc) and building age. In
      subsequent steps, building simulation templates will be assigned to each archetype. Click on
      the button below to head over the Building Stock Segmentation page.
    </Typography>
  )
}

export const TaskActionSegment: React.FC = () => {
  const classes = useStyles()
  const dispatch = useDispatch()
  const { data: project, isLoading: projectIsLoading } = getProject.useQuery('')
  const loading = useSelector(isLoading)
  const { goToTab } = useTabNavigation()

  const loadGroupDataFromCloud = useCallback(() => {
    if (!project) return
    dispatch(clearAllData())
    dispatch(setCloudContext(true))
    dispatch(setEntrypoint({ entrypoint: Entrypoint.full }))
    dispatch(loadGroupData(project.archetypeDefinition))
  }, [dispatch, project])

  const goToArchetypeDefinition = useCallback(() => {
    loadGroupDataFromCloud()
    goToTab('../umibuilder/organize')
  }, [loadGroupDataFromCloud, goToTab])

  if (projectIsLoading || !project) return <LinearProgress />
  return (
    <Button
      size='small'
      variant='contained'
      color='primary'
      onClick={goToArchetypeDefinition}
      endIcon={<CallSplitIcon />}
      disabled={loading}
      className={classes.left}
    >
      Segment Building Stock
    </Button>
  )
}
